import { useAppSelector } from "@app/hooks";
import { RootState } from "@app/store";
import { PropertyManifestEntry } from "@features/home-manifest/types";
import CategoryReadingIcon from "@features/home-status/components/CategoryReadingIcon";
import { ReadingPair } from "@features/home-status/types";
import { ManifestDevice } from "@features/plan-manifest/types";
import { Category, Measure } from "@lib/labels";
import { formatLabel } from "@lib/utils";
import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";


type Props = {
  evseEntry?: PropertyManifestEntry;
}

const TotalEnergyOutput = (props: Props) => {
  const { evseEntry } = props;
  const property = useAppSelector((state: RootState) => state.property);

  const devices = useMemo(() => property.devices || [], [property.devices]);

  const outputTotalSensor = useMemo(() => (evseEntry?.device as ManifestDevice)?.sensors
    ?.find(s => s.sensor_category === Category.power && s.measure_name === Measure.output_total), [evseEntry?.device]);

  const outputTotalDevice = useMemo(() => devices
    .find(r => r.data.entity_id === evseEntry?.sensor_map?.[outputTotalSensor?.sensor_id ?? outputTotalSensor?.friendly_name ?? '']), [outputTotalSensor?.sensor_id, outputTotalSensor?.friendly_name, devices, evseEntry?.sensor_map]);

  const outputTotalReading = useMemo(() => ({
    device: outputTotalDevice,
    sensor: outputTotalSensor,
    deviceName: formatLabel((evseEntry?.device as ManifestDevice)?.friendly_name
      || (evseEntry?.device as ManifestDevice)?.manufacturer || ''),
    area: formatLabel(evseEntry?.property_area || ''),
    entryId: evseEntry?.manifest_entry_id,
  } as ReadingPair), [evseEntry?.device, evseEntry?.manifest_entry_id, evseEntry?.property_area, outputTotalDevice, outputTotalSensor]);


  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h6">Total Energy Output</Typography>
      <CategoryReadingIcon
        category={Category.power}
        measure={Measure.output_total}
        readings={outputTotalReading}
      />
    </Stack>
  );
}

export default TotalEnergyOutput;